import { EventTriggerNames, PlatformName } from './types/new-types';

type EventsNamesMap = Record<EventTriggerNames, string>;
type PlatformNamesMap = Record<PlatformName, EventsNamesMap>;

const gtmEventsMap: EventsNamesMap = {
  user_data: 'user_data',
  login: 'login',
  sign_up: 'sign_up',
  click_generation_start: 'click_generation_start',
  style_change_save: 'style_change_save',
  file_generation_start: 'file_generation_start',
  file_generation_first_slide: 'file_generation_first_slide',
  file_generation_done: 'file_generation_done',
  scratch_generation_first_slide_start: 'scratch_generation_first_slide_start',
  scratch_generation_first_slide_done: 'scratch_generation_first_slide_done',
  generation_slide_start: 'generation_slide_start',
  generation_slide_done: 'generation_slide_done',
  design_editing: 'design_editing',
  design_editing_canvas: 'design_editing',
  file_rename: 'file_rename',
  trial_popup_close: 'trial_popup_close',
  file_delete: 'file_delete',
  click_file_download: 'click_file_download',
  file_create_duplicate: 'file_create_duplicate',
  trial_popup_to_checkout: 'trial_popup_to_checkout',
  share: 'share',
  file_download: 'file_download',
  onboarding_submit: 'onboarding_submit',
  payment_refuse_survey_close: 'payment_refuse_survey_close',
  payment_refuse_survey_to_checkout: 'payment_refuse_survey_to_checkout',
  payment_refuse_survey_answer: 'payment_refuse_survey_answer',
  service_error_system: 'service_error_system',
  service_error_preview: 'service_error_preview',
  generation_add_slide: 'generation_add_slide',
  generation_delete_slide: 'generation_delete_slide',
  generation_duplicate_slide: 'generation_duplicate_slide',
  generation_move_slide: 'generation_move_slide',
  slideshow_started: 'slideshow_started',
  begin_checkout: 'begin_checkout',
};

export const platformsEventsNameMap: PlatformNamesMap = {
  [PlatformName.GTM]: gtmEventsMap,
};
